import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';
import { logger } from '../utils/logger';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
	logger.error('Missing Supabase environment variables', {
		hasUrl: Boolean(supabaseUrl),
		hasAnonKey: Boolean(supabaseAnonKey),
	});
	throw new Error('Missing Supabase environment variables');
}

if (import.meta.env.DEV) {
	logger.info('Supabase client configured', {
		hasUrl: Boolean(supabaseUrl),
		hasAnonKey: Boolean(supabaseAnonKey),
	});
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
	auth: {
		// Enable persistent sessions that last 30 days
		persistSession: true,
		storageKey: 'wt-admin-auth',
		storage: window.localStorage,
		// Set session to last 30 days (in seconds)
		autoRefreshToken: true,
		detectSessionInUrl: true,
		debug: import.meta.env.DEV,
	},
	global: {
		headers: {
			'X-Client-Info': 'wt-portfolio-admin',
		},
	},
});

if (import.meta.env.DEV) {
	logger.debug('Supabase client created successfully');
}
